module.exports = __webpack_public_path__ + "img/10.6f9b4963.png";